import React, { useState, useEffect } from "react";
import api from "../../../api/api";
import ParentPanel from "../panel/ParentPanel";
import "../styles/SchoolTimetable.css";

const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const timetableData = [
  { period: "1st", time: "9:00 - 10:00", start: 9, end: 10 },
  { period: "2nd", time: "10:00 - 11:00", start: 10, end: 11 },
  { period: "3rd", time: "11:00 - 12:00", start: 11, end: 12 },
  { period: "4th", time: "12:00 - 1:00", start: 12, end: 13 },
  { period: "Lunch", time: "1:00 - 2:00", break: true },
  { period: "5th", time: "2:00 - 3:00", start: 14, end: 15 },
  { period: "6th", time: "3:00 - 4:00", start: 15, end: 16 },
  { period: "7th", time: "4:00 - 5:00", start: 16, end: 17 },
  { period: "8th", time: "5:00 - 6:00", start: 17, end: 18 },
];

const SchoolTimetable = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [timetable, setTimetable] = useState({});
  const [currentPeriod, setCurrentPeriod] = useState(null);

  const token = localStorage.getItem("token");

  // Fetch timetable for logged-in student
  useEffect(() => {
    const fetchTimetable = async () => {
      try {
        const res = await api.get("/api/timetable/student", {
          headers: { Authorization: `Bearer ${token}` },
        });

        console.log("Student timetable:", res.data);

        const data = {};
        days.forEach((d) => {
          if (res.data[d] && res.data[d].length > 0) {
            // Ensure array of slots per period
            data[d] = res.data[d].map((slot) => {
              // Wrap single object in array if backend sends object
              if (Array.isArray(slot)) return slot;
              return [slot];
            });
          } else {
            // Empty placeholder for days without timetable
            data[d] = timetableData.map((slot) =>
              slot.break
                ? [slot] // wrap break in array
                : [{ subject_name: "", teacher_name: "", room: "", message: "" }]
            );
          }
        });

        setTimetable(data);
      } catch (err) {
        console.error("Failed to fetch timetable:", err);
      }
    };

    fetchTimetable();
  }, [token]);

  // Auto detect current period
  useEffect(() => {
    const checkPeriod = () => {
      const now = new Date();
      const hour = now.getHours();
      const active = timetableData.find(
        (slot) => !slot.break && slot.start <= hour && hour < slot.end
      );
      setCurrentPeriod(active ? active.period : null);
    };

    checkPeriod();
    const interval = setInterval(checkPeriod, 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
  <>
    <ParentPanel onToggle={setIsSidebarCollapsed} />

    {/* ✅ Added wrapper so CSS .timetable-wrapper applies */}
    <div className="timetable-wrapper">
      <div className={`admin-main-content ${isSidebarCollapsed ? "collapsed" : ""}`}>
        <div className="dashboard-topbar">
          <span className="date-time">
            TODAY IS {new Date().toLocaleString()}
          </span>
          <span className="school-name">Semigon Learning</span>
        </div>

        <h1 className="timetable-title">📚 My Class Timetable</h1>

        <div className="timetable-container">
          <table className="timetable">
            <colgroup>
              <col />
              <col />
              {days.map((_, i) => (
                <col key={i} />
              ))}
            </colgroup>

            <thead>
              <tr>
                <th>Period</th>
                <th>Time</th>
                {days.map((day, i) => (
                  <th key={day} className={`day-header day-${i}`}>
                    {day}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {timetableData.map((row, idx) => (
                <tr
                  key={idx}
                  className={`${row.break ? "break-row" : ""} ${
                    currentPeriod === row.period ? "current-row" : ""
                  }`}
                >
                  <td>{row.period}</td>
                  <td>{row.time}</td>
                  {days.map((day, i) => {
                    const slots = timetable[day]?.[idx] || [];

                    if (row.break) {
                      return (
                        <td key={i} colSpan={days.length} className="lunch-cell">
                          🍴 Lunch Break
                        </td>
                      );
                    }

                    return (
                      <td key={i}>
                        {slots.map((slot, j) => (
                          <div
  key={j}
  className={`subject-card ${currentPeriod === row.period ? "active" : ""}`}
  data-subject={slot.subject_name}
>
                            <div className="subject-name">
                              {slot.subject_name}
                            </div>
                            <div className="teacher-name">
                              {slot.teacher_name}
                            </div>
                            <div className="tooltip">
                              <strong>Subject:</strong> {slot.subject_name}{" "}
                              <br />
                              <strong>Teacher:</strong> {slot.teacher_name}{" "}
                              <br />
                              <strong>Room:</strong> {slot.room} <br />
                              <strong>Notes:</strong> {slot.message}
                            </div>
                          </div>
                        ))}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </>
);

};

export default SchoolTimetable;
